module.exports = __webpack_public_path__ + "img/true_charge_logo.00d87233.png";